import { render, staticRenderFns } from "./YearOnYearBreakdown.vue?vue&type=template&id=6149a28a&scoped=true&"
import script from "./YearOnYearBreakdown.vue?vue&type=script&lang=ts&"
export * from "./YearOnYearBreakdown.vue?vue&type=script&lang=ts&"
import style0 from "./YearOnYearBreakdown.vue?vue&type=style&index=0&id=6149a28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6149a28a",
  null
  
)

export default component.exports